import React, { useState, useEffect } from "react";
//Styles
import "../../../../assets/css/form.css";
//Cookie token
import cookie from "react-cookies";
//Router
import { useHistory, useParams } from "react-router-dom";
//GraphQL
import { useLazyQuery, gql } from "@apollo/client";
//Redux
import { useDispatch, useSelector } from "react-redux";
import {
  loadFormSettings,
  loadFormValue,
} from "../../../../actions/formDataActions";
//Components
import Form from "../../../formSections/Form";

const ProvincesUpdate = () => {
  //Redirect if not logged in
  let history = useHistory();
  const token = cookie.load("usertk");
  let { id } = useParams();

  //Store data
  const { settings } = useSelector((state) => state.dataForm);

  //States
  const [displayForm, setDisplayForm] = useState(false);

  //API
  const GET_PROVINCE_2UPDATE = gql`
    query getProvince {
      getProvince(id: ${id}) {
        id
        name
        country {
          name
          id
        }
      }
    }
  `;

  const [getProvince, { error, data }] = useLazyQuery(GET_PROVINCE_2UPDATE);

  //Redux actions
  const dispatch = useDispatch();
  const storeLoadFormValue = (valuePair) => dispatch(loadFormValue(valuePair));
  const storeLoadSettings = (defaultSettings) =>
    dispatch(loadFormSettings(defaultSettings));

  //useEffect
  useEffect(() => {
    if (settings && settings !== {}) {
      setDisplayForm(true);
    } else {
      setDisplayForm(false);
    }
    // eslint-disable-next-line
  }, [settings]);

  useEffect(() => {
    if (data && !error) {
      //Section Settings
      const defaultSettings = {
        id: id,
        mutationBackID: data.getProvince.country.id,
        entity: "province",
        queryName: "updateProvince",
        title: "Editar provincia de " + data.getProvince.country.name,
        text: "Por favor, modifique el nombre de la provincia y después pulse en aceptar para que los cambios se guarden.",
        formContent: [
          {
            type: "fieldText",
            name: "name",
            size: 75,
            label: "Nombre de la provincia",
            placeholder: "Nombre de la provincia",
            required: true,
            validated: true,
            validation: "notEmpty",
            defaultValue: data.getProvince.name,
          },
          {
            type: "buttons",
            buttons: [
              {
                text: "Actualizar",
                action: "update",
                classes: "safe",
                actionType: "update",
                entity: "province",
                id: id,
              },
              {
                text: "Cancelar",
                action: "link",
                link: "/provincias/ver/",
                classes: "unsafe",
                entity: "province",
              },
            ],
          },
        ],
      };
      storeLoadSettings(defaultSettings);
      //Load ids values to store
      storeLoadFormValue(["id", parseInt(id)]);
      storeLoadFormValue(["country_id", data.getProvince.country.id]);
    }

    // eslint-disable-next-line
  }, [data, error]);

  useEffect(() => {
    getProvince();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      {!token ? (
        history.push("/")
      ) : (
        <>
          <div className="table-container">{displayForm && <Form />}</div>
        </>
      )}
    </>
  );
};

export default ProvincesUpdate;
